import { createClient } from '@supabase/supabase-js';

/**
 * Creates a Supabase client with x-session-token header set.
 * Use this for queries on room_participants that need session_token auth.
 */
export function createSessionClient(sessionToken: string) {
  return createClient(
    import.meta.env.VITE_SUPABASE_URL,
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
    {
      global: {
        headers: { 'x-session-token': sessionToken },
      },
    }
  );
}
